import {
  Behaviour,
  BoxCollider,
  EventList,
  GameObject,
  ICollider,
  serializable,
} from "@needle-tools/engine";
import { Tags } from "./Consts";
import { RaceOrderManager, RacerEntry } from "./RaceOrderManager";

export class CheckpointCounter extends Behaviour {
  @serializable()
  public totalHorsesCollided: number = 0;
  private racerArray: RacerEntry[] = [];

  public checkpointReached: boolean = false;

  private raceOrderManager?: RaceOrderManager;

  @serializable(GameObject)
  public nextCheckpoint?: GameObject;

  public isFinishLine: boolean = false;


  private checkpointInteractedWith: boolean = false;

  @serializable(EventList)
  public onCheckpointInteractedWith?: EventList;


  @serializable(EventList)
  public onRacerCrossedFinishLine?: EventList;

  public setRaceOrderManager(raceOrderManager: RaceOrderManager) {
    this.raceOrderManager = raceOrderManager;
  }

  public getRaceOrderManager(): RaceOrderManager | undefined {
    return this.raceOrderManager;
  }

  public resetCheckpoint() {
    this.totalHorsesCollided = 0;
    this.checkpointReached = false;
  }

  onTriggerEnter(col: ICollider) {
    if (col.tag == Tags.RACER && !this.checkpointReached) {
      this.totalHorsesCollided++;

      if(this.raceOrderManager == null) {
        console.log("Race order manager is null ")
      }

      if(this.checkpointInteractedWith == false) {
        this.CheckpointInteractedWith();
      }

      if (
        !this.racerArray.some(
          (entry) => entry.racerNumber === col.gameObject.name,
        )
      ) {
        const racerEntry = this.raceOrderManager?.ReturnRacerEntryByNumber(
          Number(col.gameObject.name),
        );
        if (racerEntry) {
          this.racerArray.push(racerEntry);
        }
      }

      if (this.totalHorsesCollided == 6) {
        const collider = this.gameObject.getComponent(BoxCollider);
        if (collider) {
          collider.enabled = false;
        }
        
        this.raceOrderManager?.UpdateRaceOrder(this);
        this.checkpointReached = true;

        //clear the racer array
        this.racerArray = [];


        if (this.isFinishLine) {
          console.log("Race Complete!");
          this.onRacerCrossedFinishLine?.invoke();
        }
      }

      //this.raceOrderManager?.UpdateRaceOrder(this.nextCheckpoint);
    }
  }

  private CheckpointInteractedWith() {
    this.checkpointInteractedWith = true;
    this.onCheckpointInteractedWith?.invoke();
  }

  public GetRacerArray(): RacerEntry[] {
    return this.racerArray;
  }
}
